<template>
	<div class="modal_info modal_delete">
		<div class="header-submodal">
			<div class="image"><img src="/build/images/not-allowed.svg"></div>
			<div class="title">{{ $t('procedures.confirm_restore_title') }}</div>
		</div>
		<div class="description-modal">
			{{ $t('procedures.confirm_restore_text') }}
		</div>

		<div class="button-actions">
			<button class="btn-tbf white center" @click="cancelRestore">
				<div class="text">{{ $t('general.cancel') }}</div>
			</button>
			<button id="submitRestoreBtn" class="btn-tbf blue center" @click="submitRestore">
				<div class="loader"></div>
				<div class="text">{{ $t('general.submit') }}</div>
			</button>
		</div>
	</div>
</template>

<script type="text/javascript">

	export default {
		data() {
			return {
			};
		},
		props: {
			data: Object
		},
		mounted() {
			
		},
		methods: {
			cancelRestore(){
				this.$emit("close_modal");
			},
			submitRestore(){
				var buttonName = `submitRestoreBtn`
				var btnSubmit = document.getElementById(buttonName);
				var btnSubmitLoader = document.querySelector(`#${buttonName} .loader`)
				var btnSubmitText = document.querySelector(`#${buttonName} .text`)
				btnSubmit.disabled = true

				btnSubmit.classList.add('loading')
				btnSubmitLoader.classList.add('onProgress')
				btnSubmitText.innerHTML = this.$t('btn-submit.loading')

				this.error_message = ''

				axios.post(`/procedure-histories/${this.data.version.id}/activate-history`)
				.then(({data}) => {
					this.$root.$emit('refreshVersionsHistory')

					btnSubmitLoader.classList.add('finish')
					setTimeout(()=>{
						btnSubmitText.innerHTML = this.$t('btn-submit.success')
						btnSubmit.classList.add('completed')
						btnSubmitLoader.classList.remove('onProgress', 'finish')
						btnSubmit.classList.remove('loading')
						setTimeout(()=>{
							btnSubmit.classList.remove('completed')
						}, 1000)
					}, 300)
				}).catch(error => {
					btnSubmitLoader.classList.add('finish')
					setTimeout(()=>{
						btnSubmitText.innerHTML = this.$t('btn-submit.error')
						btnSubmit.classList.add('error')
						btnSubmitLoader.classList.remove('onProgress', 'finish')
						btnSubmit.classList.remove('loading')
						setTimeout(()=>{
							btnSubmit.classList.remove('error')
							btnSubmitText.innerHTML = this.$t('general.submit')
							btnSubmit.disabled = false
							if(error.response.status == 500){
								this.error_message = this.$t('error.500')
							}
						}, 1000)
					}, 300)
				})
				.finally(() => {
					setTimeout(()=>{
						this.$emit("close_modal")
					}, 1000)
				})
			}
		}
	};
</script>